export const getWholeAndDecimal = (value) => {
    const guardNaN = (value) => (isFinite(value) ? value : 0);
    const [whole, decimal] = String(value).split('.');
    // return [Number(guardNaN(whole)), Number(guardNaN(decimal))];
    return [whole, decimal];
};
